import React from 'react';
import { Target, Activity, Cpu, Rss } from 'lucide-react';
const features = [{
  title: 'Rival Tracking',
  description: 'Monitor competitor moves in real-time. Track pricing changes, product launches, and marketing campaigns instantly.',
  icon: Target,
  color: 'text-[#00d4ff]'
}, {
  title: 'Market Pulse',
  description: 'Live market sentiment analysis using advanced NLP to gauge brand perception and customer satisfaction across channels.',
  icon: Activity,
  color: 'text-green-400'
}, {
  title: 'Strategy Forge',
  description: 'AI-powered strategic recommendations based on historical data patterns and predictive modeling of competitor behavior.',
  icon: Cpu,
  color: 'text-purple-400'
}, {
  title: 'Intel Feeds',
  description: 'Aggregated intelligence streams from news, social media, financial reports, and insider leaks in one dashboard.',
  icon: Rss,
  color: 'text-yellow-400'
}];
export function Features() {
  return <section className="py-24 bg-[#0a1628] relative" data-id="element-39">
      <div className="container mx-auto px-4" data-id="element-40">
        <div className="text-center mb-16" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-42">
            TACTICAL CAPABILITIES
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto" data-id="element-43">
            Equip your organization with the tools needed to outmaneuver the
            competition.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-44">
          {features.map((feature, index) => <div key={index} className="group relative bg-[#1a2942] p-6 rounded-lg border border-slate-700 hover:border-[#00d4ff] transition-all duration-300 hover:shadow-[0_0_20px_rgba(0,212,255,0.1)] overflow-hidden" data-id="element-45">
              {/* Corner Accents */}
              <div className="absolute top-0 left-0 w-2 h-2 border-t-2 border-l-2 border-[#00d4ff] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-46"></div>
              <div className="absolute top-0 right-0 w-2 h-2 border-t-2 border-r-2 border-[#00d4ff] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-47"></div>
              <div className="absolute bottom-0 left-0 w-2 h-2 border-b-2 border-l-2 border-[#00d4ff] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-48"></div>
              <div className="absolute bottom-0 right-0 w-2 h-2 border-b-2 border-r-2 border-[#00d4ff] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-49"></div>

              <div className={`mb-4 p-3 rounded bg-[#0a1628] inline-block ${feature.color}`} data-id="element-50">
                <feature.icon className="w-8 h-8" data-id="element-51" />
              </div>

              <h3 className="text-xl font-bold text-white mb-2 font-mono" data-id="element-52">
                {feature.title}
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-53">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}